export enum LogoType {
  FullWhite = 0,
  FullSand = 1,
  SmallSand = 2,
  AnimatedSand = 3
}
